import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

// Hubsys useZoomWarning 차용 — 100% 배율 권장, 범위를 크게 벗어나면 안내
const ZOOM_MIN = 0.8; // 80% 미만이면 경고
const ZOOM_MAX = 1.3; // 130% 초과하면 경고
const TOAST_ID = 'zoom-warning';
const MOBILE_QUERY = '(max-width: 767px)';

/**
 * 브라우저 확대/축소 배율이 권장 범위(80~130%)를 벗어나면 Toast로 안내한다.
 * - devicePixelRatio 기반. 모바일은 DPR이 2~3이라 항상 걸리므로 제외.
 * - dismiss는 세션 메모리(useRef) 기반: 한 번 닫으면 그 세션 동안 침묵,
 *   배율이 정상 범위로 복귀하면 다시 활성화된다.
 */
export function useZoomWarning() {
  const dismissed = useRef(false);

  useEffect(() => {
    function check() {
      // 모바일에서는 devicePixelRatio가 보통 2~3이라 항상 경고가 떠서 비활성화
      if (window.matchMedia(MOBILE_QUERY).matches) {
        toast.dismiss(TOAST_ID);
        return;
      }

      const ratio = Math.round(window.devicePixelRatio * 100) / 100;
      const isOutOfRange = ratio < ZOOM_MIN || ratio > ZOOM_MAX;

      if (isOutOfRange && !dismissed.current) {
        const pct = Math.round(ratio * 100);
        toast.warning('브라우저 확대/축소 감지', {
          id: TOAST_ID,
          description: `현재 ${pct}% 배율입니다. 레이아웃이 깨질 수 있으니 100%로 조정해 주세요. (Ctrl + 0)`,
          duration: 8000,
          onDismiss: () => {
            dismissed.current = true;
          },
        });
      } else if (!isOutOfRange) {
        dismissed.current = false;
        toast.dismiss(TOAST_ID);
      }
    }

    check();

    // resize 이벤트로 zoom 변화 감지 (브라우저 줌 시 resize 발생)
    const onResize = () => check();
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, []);
}
